<div class="section-title">
  <div class="mt-2" aria-hidden="true">
    <!-- <button style="float: right;" type="button" (click)="savebtnclicked()" class="btn cornblue">Save</button> -->
  </div>
</div>
<div class="row">
  <div class="col" style="text-align: left;">
    <span *ngIf="wordcountdisplay"  aria-live="polite" aria-atomic="true" [ngClass]="{'higlight': higlight}">{{wordcountdisplay}}</span>
  </div>
  <div class="col" style="text-align: right;">
    <span *ngIf="maxwordcount" style="color: red;"  aria-live="polite" aria-atomic="true">{{language.limitOf}} {{maxwordcount}}
      {{language.wordsMaximum}}</span>
  </div>
</div>
<div style="width: 100% !important;" spellcheck="false">
  <app-quill-editor required #answer name="answer" [placeholder]="language.quillEditorPlaceHolderMessage" [readOnlyMessage]="language.quillEditorEssayReadOnlyMessage"
    (valueChange)="onEditorContentChange($event)" (editorCreated)="onEditorCreated()" [maxWordCount]="maxwordcount">
  </app-quill-editor>
</div>
<div class="row">
  <div class="col" style="text-align: left;">
    <span *ngIf="wordcountdisplay" [ngClass]="{'higlight': higlight}" aria-hidden="true">{{wordcountdisplay}}</span>
  </div>
  <div class="col" style="text-align: right;">
    <span *ngIf="maxwordcount" style="color: red;" aria-hidden="true">{{language.limitOf}} {{maxwordcount}}
      {{language.wordsMaximum}}</span>
  </div>
</div>
<div class="mt-2 text-muted small" *ngIf="lastSavedTime" role="status" aria-live="polite">
  <em>Last saved (auto): {{getLastSavedText()}}</em><br/>
  <!-- <button *ngIf="timeSinceLastSave > 10" class="btn btn-sm btn-primary" (click)="saveButtonClicked()">Save Progress</button> -->
</div>